import { makeAutoObservable } from 'mobx';
import { IDumGlobalEventDetailHoverData } from '../DUMEvents/DUMEvents.type';

export interface IFormTemporary {
  name: string;
  date: string;
  link: string;
  description: string | undefined;
  latitude: string;
  longitude: string;
  /**
   * Optional event banner. Carried through the "Change Location" round-trip so
   * an already picked image is not silently dropped when the user goes to the
   * map and comes back.
   */
  banner?: File | null;
  /**
   * Optional external video URL, carried through the same "Change Location"
   * round-trip as `banner`.
   */
  bannerUrl?: string;
}

export interface IFormStore {
  show: boolean;
  isChangeLocation: boolean;
  latitude: string;
  longitude: string;
  temporaryData?: IFormTemporary;
  showModal: () => void;
  hideModal: () => void;
  setActiveChangeLocation: () => void;
  setNonActiveChangeLocation: () => void;
  setCoordinate: (lat: string, lon: string) => void;
  clearCoordinate: () => void;
  isDetailVisible: boolean;
  selectedEvent: IDumGlobalEventDetailHoverData | null | undefined;
}

export class FormStore implements IFormStore {
  show = false;
  isChangeLocation = false;
  latitude = '0';
  longitude = '0';
  isDetailVisible = false;
  selectedEvent = null;
  temporaryData?: IFormTemporary = undefined;

  constructor() {
    makeAutoObservable(this);
    this.show = false;
    this.isChangeLocation = false;
    this.latitude = '0';
    this.longitude = '0';
    this.isDetailVisible = false;
  }

  showModal() {
    this.show = true;
  }

  hideModal() {
    this.show = false;
  }

  setActiveChangeLocation() {
    this.isChangeLocation = true;
  }

  setNonActiveChangeLocation() {
    this.isChangeLocation = false;
  }

  setCoordinate(lat: string, lon: string) {
    this.latitude = lat;
    this.longitude = lon;
  }

  clearCoordinate() {
    this.latitude = '0';
    this.longitude = '0';
  }
}

export const FormStoreDefault: IFormStore = {
  show: false,
  isChangeLocation: false,
  latitude: '0',
  longitude: '0',
  showModal: () => null,
  hideModal: () => null,
  setActiveChangeLocation: () => null,
  setNonActiveChangeLocation: () => null,
  setCoordinate: () => null,
  clearCoordinate: () => null,
  isDetailVisible: false,
  selectedEvent: null
};
